import { render, staticRenderFns } from "./PurchasedItem.vue?vue&type=template&id=2f6f885e&scoped=true"
import script from "./PurchasedItem.vue?vue&type=script&lang=js"
export * from "./PurchasedItem.vue?vue&type=script&lang=js"
import style0 from "./PurchasedItem.vue?vue&type=style&index=0&id=2f6f885e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f885e",
  null
  
)

export default component.exports